import { MutationHookOptions, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import { EditEventSettingsMutation as EditEventSettings, EditEventSettingsInput } from '__generated__/graphql';
import { useNotifier } from '../../../../common/Notifications/NotificationProvider';
import EditEventSettingsMutation from './EditEventSettingsMutation';
import useScroll from '../../../../common/useScroll';

interface UseEditEventMutationProps {
  input: EditEventSettingsInput;
  onSuccess?: (event: EditEventSettings['editEventSettings']) => void;
  onError?: MutationHookOptions['onError'];
}

const useEditEventMutation = ({ input, onSuccess, onError }: UseEditEventMutationProps) => {
  const { t } = useTranslation();
  const notifier = useNotifier();
  const { scrollTo } = useScroll();

  return useMutation(EditEventSettingsMutation, {
    variables: {
      input,
    },
    onCompleted: ({ editEventSettings: event }) => {
      notifier.success(t('notifications.event_saved'));

      onSuccess?.(event);
    },
    onError: (error, options) => {
      scrollTo('EventTab');

      onError?.(error, options);
    },
  });
};

export default useEditEventMutation;
